import React, { Fragment, useState } from 'react';

const SignIn = ({ setAuth, setAdm }) => {

    const [worker_email, setWorker_email] = useState("");
    const [worker_password, setWorker_password] = useState("");
    const [failure, setFailure] = useState(false);



    const onSubmitForm = async (e) => {
        e.preventDefault();
        try {
            // worker_password = hash.update(worker_password, 'utf-8').digest('hex')
            const body = { worker_email, worker_password };

            const response = await fetch("https://www.beyondcommunityaccess.com/auth/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body)
            });
            const parseRes = await response.json();
            if (parseRes.token === undefined) {
                setFailure(true);
                return;
            }
            localStorage.setItem("token", parseRes.token);

            setAuth(true);
            if (parseRes.admin === 1) {
                setAdm(1);
            } else if (parseRes.admin === 2) {
                setAdm(2);
            } else {
                setAdm(0);
            }

        } catch (err) {
            console.error("Cannot login");
            console.error(err.message);
        }
    }
    return (
        <Fragment>
            <div className="container">
                <h2 className="text-center my-5">Log In</h2>
                <form className="mt-5 text-center" onSubmit={onSubmitForm}>
                    <h6>Email</h6>
                    <input placeholder="Email" type="text" className="form-control" value={worker_email} onChange={e => setWorker_email(e.target.value)} />
                    <h6 className="mt-2">Password</h6>
                    <input placeholder="Password" type="password" className="form-control" value={worker_password} onChange={e => setWorker_password(e.target.value)} />
                    <button className="btn btn-success btn-block mt-2" >Login</button>
                    {failure && <h6 className="mt-2 text-danger">Invalid Details</h6>}

                </form>

            </div>
        </Fragment>
    )
}

export default SignIn;
